import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import ProfileAvatar from '../../common/avatar/ProfileAvatar'

import classes from './WaitlistTooltip.module.scss'

const WaitlistTooltip = ({ program }) => {
  const { t } = useTranslation()

  return (
    <ReactTooltip
      id={`waitlistTooltip-${program.id}`}
      effect='solid'
      delayUpdate={1000}
      delayHide={100}
      place={'bottom'}
      className={classes.waitlistTooltip}
    >
      <div className={classes.tooltipSection}>
        <h5 className={classes.tooltipTitle}>
          {t('programs.waitlistDetails.waitlistTooltip.waitlistedCount', {
            count: program.waitlistedStudents.length,
          })}
        </h5>
      </div>
      <div className={classes.tooltipSection}>
        <h5 className={classNames(classes.tooltipTitle, 'mb-2')}>
          {t('programs.waitlistDetails.waitlistTooltip.waitlisted')}
        </h5>
        <ul className={classNames(classes.students)}>
          {program.waitlistedStudents.map((student) => (
            <li key={student.id} className='mb-2'>
              <ProfileAvatar student={student} withName withoutMilestone />
            </li>
          ))}
        </ul>
      </div>
    </ReactTooltip>
  )
}

WaitlistTooltip.propTypes = {
  program: PropTypes.shape({
    id: PropTypes.number,
    waitlistedStudents: PropTypes.array,
  }),
}

export default WaitlistTooltip
